import { CourseSubjectType } from "./CourseSubject";
import { PaymentReferenceType, PaymentTransactionType } from "./Finance";
import { PlanSubjectType } from "./PlanSubject";
import { SubjectType } from "./Subject";
import { UserType } from "./User"
export type DocumentType = {
  id: string;
  file: File;
};
export type CreateEnrollmentType = {
  id?: string;
  idStudent?: string;
  student?: string;
  idCourse: string;
  course?: string;
  faculty?: string;
  departament?: string;
  date?: string;
  idAcademicYear?: string;
  academicYear?: string;
  status?: boolean;
  regime?: number;
  subscribeStudent?: boolean;
  idPlan?: string;
  syncData?: any;
}
export type StudentList = {
  list?: {
    SchoolCode?: string,
    Fullname?: string,
  }[],
  filters?: {
    AcademicYear?: string;
    Regime?: string;
    Class?: string;
    Level?: number;
    Semester?: number;
    University?: string;
    Faculty?: string;
    Departament?: string;
    Course?: string;
    Subject?: string;
    TotalItems?: number;
    TotalOnPage?: number;
    TotalPages?: number;
    PageNumber?: number;
  }
}
export type StudentGrade = {
  tableData?: { headers: string[]; rows: string[][] },
  filters?: {
    AcademicYear?: string;
    Regime?: string;
    Class?: string;
    Level?: number;
    Semester?: number;
    University?: string;
    Faculty?: string;
    Departament?: string;
    Course?: string;
    Subject?: string;
    TotalItems?: number;
    TotalOnPage?: number;
    TotalPages?: number;
    PageNumber?: number;
    title?: string;
  }
}
export type CreateStudentType = {
  bankEntity?: string,
  isGenerateMonthly?: boolean,
  paymentTypeId?: string,
  students?: StudentList,
  user: {
    id?: string;
    name: string;
    userName?: string;
    email?: string;
    secondaryEmail?: string;
    secondaryPhoneNumber?: string;
    bi: string;
    nuit: string;
    phoneNumber: string;
    dateOfBirth: string;
    gender: 'M' | 'F';
    role?: string;
    icon?: any;
    lockoutEnabled?: boolean;
    password?: string;
    isForeign: boolean;

    //roles?: GetUserRolesType[];
    //claims?: GetUserClaimsType[];
  }
  documents: Array<{
    id: string;
    file: File;
  }>;
  holdDocuments?: { id?: string }[];
  enrollment: CreateEnrollmentType
  idFaculty: string;
  idUniversity?: string;
  idDepartament: string;
  idPlan: string;
  idSubscription?: string;
  enrollment_date?: string,
  documentsStringfied?: string;
  storeDocuments?: EnrollmentDocumentType[],
  student?: StudentType,
  subscribeStudent: boolean,
  isInternStudent: boolean,
  course?: string;
  departament?: string;
  requiredDocuments?: any[]
  certificate?: StudentCertificateType
  schoolCode?: string | null | undefined,
  year?: number,
  semester?: number,
  // isForeign:boolean;  
  idPlaceOfBirth?: string;
  idCountry?: string;
  enrollmentYear?: number;
  countryDescription?: string;
  retrySubjectsReproved?: [],
  subjectsSubscriptions?: [],
  payment?: {
    isPaymentByEntityReference?: boolean
    bankName?: string
    bankDescription?: string
    entity?: string
    totalPrice?: string | number
    reference?: string,
    idStudentDebt?: string,
    paymentProofEnrollment?: any
    paymentProofSubscription?: any
    paymentProofPerSubject?: any
    paymentProof?: any
    idBankEntity?: string,
    idPaymentTypeEnrollment?: string,
    idPaymentTypeSubscription?: string,
    idPaymentTypePerSubject?: string,
    idPaymentTypeMonograph?: string,
  },
  isChangedCourse?: boolean,
  studentsGrades?: StudentGrade,
};

export type StudentType = {
  idUser: string;
  id?: string;
  enrollmentDate?: string;
  studentUniversalCode: string;
  schoolCode?: string;
  idFaculty?: string;
  idUniversity?: string;
  idDepartament?: string;
  idCourse?: string;
  faculty?: string;
  departament?: string;
  course?: string;
  idEnrollment?: string;
  fullname?: string;
  regime?: number;
  isForeign?: boolean;
  idPlaceOfBirth?: string;
  idCountry?: string;
  enrollmentYear?: number | string;
  countryDescription?: string;
  eletronicDevice?: string;
  specialConditions?: string;
  province?: string;
  provinceGraduated12OrEqual?: string;
  localGraduated12OrEqual?: string;
  idPlan?: string;
  syncData?: GenerateCodeStudentType;
  father?: string;
  mother?: string;
  dateDocumentValidate?: string;
  dateDocumentEmmited?: string;
}
export type StudentCertificateType = {
  grades: any[],
  student: StudentType
}

export type GenerateCodeStudentType = {
  nuit?: string;
  bi?: string;
  document?: string;
  provinceEnrolled?: string;
  enrollmentYear?: string;
  idCourse?: string;
  idUser?: string;
  idRegime?: number;
  iesType?: number;
  iesCode?: number;
  iesName?: string;
  courseName?: string;
  subDomain?: number;
  subDomainCode?: string;
  iesNuit?: number;
  year?: string;
  domain?: number;
  code?: string;
  dateOfBirth?: string;
  name?: string;
  phoneNumber?: string;
  gender?: string;
  isForeign?: boolean;
  country?: string;
  eletronicDevice?: string;
  specialConditions?: string;
  modality?: string;
  courseLevel?: string;
  province?: string;
  dateGraduated?: string;
  provinceGraduated12OrEqual?: string;
  localGraduated12OrEqual?: string;
  certificate?: string | null;
  canceledReason?: string | null;
  isGraduated?: boolean;
  isCancel?: boolean;
  isNewStudent?: boolean;
};
export type EnrollmentDocumentType = {
  idEnrollment?: string;
  id?: string;
  idRequiredDocument: string;
  docBase64: string | ArrayBuffer | null;
  extension?: string | null;
  name?: string | null;
}

export type SubscriptionSubjectType = {
  id?: string;
  idSubject: string;
  idSubscription: string;
  level?: number;
  semester?: number;
  status: boolean,

}
export type SubscriptionType = {
  id?: string;
  semester: number;
  idEnrollment: string;
  status?: boolean;
  reason?: string;
  level?: number;
  idAcademicYear?: string;
  academicYear?: string;
  idCourse?: string;
  idStudent?: string;
  course?: string;
  idUniversity?: string;
  studentCode?: string;
  student?: string;
  courseSubjects?: CourseSubjectType[];
  planSubjects?: PlanSubjectType[];
  year: number;
  idsSubjects?: string
  payment?: {
    isPaymentByEntityReference?: boolean
    entity?: string
    idEnrollment?: string
    totalPrice?: string | number
    reference?: string,
    idStudentDebt?: string,
    paymentProofEnrollment?: any
    paymentProofSubscription?: any
    paymentProofPerSubject?: any
    paymentProof?: any
    idBankEntity?: string,
    idPaymentTypeEnrollment?: string,
    idPaymentTypeSubscription?: string,
    idPaymentTypePerSubject?: string,
  },
  payments?: PaymentFormHelperType[],
  paymentsReferences?: PaymentReferenceType[],
  paymentsTransactions?: PaymentTransactionType[],
  studentDebtsAssociations?: any[],
  idsSubjectsArray?: string[],
  idPlan?: string,
  idValidated?: boolean,
}

export type PaymentFormHelperType = {
  isPaymentByEntityReference?: boolean
  entity?: string
  idEnrollment?: string
  totalPrice?: string | number
  reference?: string,
  idStudentDebt?: string,
  paymentProofEnrollment?: any
  paymentProofSubscription?: any
  paymentProofPerSubject?: any
  paymentProof?: any
  idBankEntity?: string,
  idPaymentTypeEnrollment?: string,
  idPaymentTypeSubscription?: string,
  idPaymentTypePerSubject?: string,
}
export type EnrollmentType = {
  id: string;
  idStudent: string;
  idAcademicYear: string;
  idCourse: string;
  idPlan: string;
  academicYear: string;
  course: string;
  student: string;
  idUser: string;
  date: string;
  status: boolean;
  fullname?: string;
  idFaculty?: string;
  faculty?: string;
  idUniversity?: string;
  university?: string;
  idDepartament?: string;
  departament?: string;
  regime?: number;
  subscribeStudent?: boolean;
  isCanceled?: boolean;
  isCanceledReason?: string;
}

export type ActiveSegmentTab = 'user' | 'documents' | "course" | "manage-subjects" | 'payments';

export type StudentClassType = {
  idStudent: string;
  idStudents: string[];
  idClass: string;
  id?: string;
  student?: string;
  studentCode?: string;
  class?: string;
  status?: boolean;
  reason?: string;
  isTransfered?: boolean;
  transferedClass?: string | null;

  IdFaculty?: string;
  IdUniversity?: string;
  IdDepartament?: string;
  IdCourse?: string;
  IdSubject?: string;
  IdAcademicYear?: string;
  Regime: number;
  Level: number;
  Semester: number;
  SemesterSubject?: number;
  LevelSubject?: number;

  haveBills?: boolean;
}





export type StudentDocumentType = {
  id?: string,
  status?: boolean,
  state: string,
  docBase64?: string,
  docType: string,
  modelType: string,
  issuedBy?: string,
  madeBy?: string,
  approvedBy?: string,
  rejectedBy?: string,
  description?: string,
  isPayed?: boolean,
  courseId: string,
  paymentMethod?: string,
  paymentProof?: any,
  paymentProofFile?: any,
  issuedDate?: string,
  madeDate?: string,
  approvedDate?: string,
  rejectedDate?: string,
  idStudent: string,
  studentCode?: string,
  student?: string,
  isUrgent: boolean,
  isValid?: boolean,
  idsPaymentTypes?: string[],
  payment?: {
    isPaymentByEntityReference?: boolean
    bankName?: string
    bankDescription?: string
    entity?: string
    totalPrice?: string | number
    reference?: string,
    idStudentDebt?: string,
    paymentProofEnrollment?: any
    paymentProofSubscription?: any
    paymentProofPerSubject?: any
    paymentProof?: any
    idBankEntity?: string,
    idPaymentTypeEnrollment?: string,
    idPaymentTypeSubscription?: string,
    idPaymentTypePerSubject?: string,
    idPaymentTypeMonograph?: string,
    idPaymentTypeStudentDocument?: string,
  },
}



export enum DocumentTypeEnum {
  DECLARACAO = "Declaração",
  CERTIFICADO = "Certificado",
  DIPLOMA = "Diploma",
  CREDENCIAL = "Credencial",
}
export const getPrintTypeForStudentDoc = (docType: string) => {
  switch (docType) {
    case DocumentTypeEnum.CERTIFICADO:
      return 'CERTIFICATE';
    case DocumentTypeEnum.CREDENCIAL:
      return 'CREDENTIAL';
    case DocumentTypeEnum.DECLARACAO:
      return 'DECLARATION';
    case DocumentTypeEnum.DIPLOMA:
      return 'DIPLOMA';
  }
}

export enum PaymentTypeEnum {
  MPESA = "Mpesa",
  BANCO = "Banco",
  TRANSFERENCIA = "Transferência",
  REFERENCIA = "Entidade-Referência",
}
export enum StateEnum {
  INITIATE = "Iniciado",
  APPROVED = "Aprovado",
  REPPROVED = "Reprovado",
  EMITTED = "Emitido",
}

export type PaymentType = 'Mpesa' | 'Banco' | 'Transferencia' | 'Entidade-Referencia';


export type SubscriptionStatisticsType = {
  academicYear: string;
  course: string;
  subject: string;
  level: number;
  regime?: number | string;
  semester: number;
  total: number;
};


export type StudentStatisticsQueryParams = {
  Gender?: string;
  MinAge?: number;
  MaxAge?: number;
  IsForeign?: boolean;
  KnowledgeDomain?: string;
  KnowledgeSubDomain?: string;
  Course?: string;
  Duration?: number;
  Level?: string;
  YearSubscription?: string;
  SemesterSubscription?: string;
  CountryOrigin?: string;
  ProvinceOrigin?: string;
  ProvinceGraduated12orEqual?: string;
  IsCanceled?: boolean; //matricula cancelada?
  IsCanceledReason?: string;
  ScholarshipType?: string;
  ScholarshipProvider?: string;
  ScholarshipPercent?: string;
  Regime?: string;
  HasElectronicDevice?: boolean;
  SpecialConditions?: string;
  idFaculty?: string;
  idUniversity?: string;
  idDepartament?: string;
  IdAcademicYear?: string;
}
export type StudentStatisticsResponse = {
  knowledgeDomain: string;
  knowledgeSubDomain: string;
  course: string;
  duration: number;
  level: string;
  studentCount: number;
  newStudents: number;
  internStudents: number;
  graduatedStudents: number;
}